import React, {useEffect, useState} from 'react';
import SelectBox from "./select-box";


const PartnersForm = () => {

    let countryList = [
        {value: 'Afghanistan', id: 'AF'},
        {value: 'Aland Islands', id: 'AX'},
        {value: 'Albania', id: 'AL'},
        {value: 'Algeria', id: 'DZ'},
        {value: 'American Samoa', id: 'AS'},
        {value: 'AndorrA', id: 'AD'},
        {value: 'Angola', id: 'AO'},
        {value: 'Anguilla', id: 'AI'},
        {value: 'Antarctica', id: 'AQ'},
        {value: 'Antigua and Barbuda', id: 'AG'},
        {value: 'Argentina', id: 'AR'},
        {value: 'Armenia', id: 'AM'},
        {value: 'Aruba', id: 'AW'},
        {value: 'Australia', id: 'AU'},
        {value: 'Austria', id: 'AT'},
        {value: 'Azerbaijan', id: 'AZ'},
        {value: 'Bahamas', id: 'BS'},
        {value: 'Bahrain', id: 'BH'},
        {value: 'Bangladesh', id: 'BD'},
        {value: 'Barbados', id: 'BB'},
        {value: 'Belarus', id: 'BY'},
        {value: 'Belgium', id: 'BE'},
        {value: 'Belize', id: 'BZ'},
        {value: 'Benin', id: 'BJ'},
        {value: 'Bermuda', id: 'BM'},
        {value: 'Bhutan', id: 'BT'},
        {value: 'Bolivia', id: 'BO'},
        {value: 'Bosnia and Herzegovina', id: 'BA'},
        {value: 'Botswana', id: 'BW'},
        {value: 'Bouvet Island', id: 'BV'},
        {value: 'Brazil', id: 'BR'},
        {value: 'British Indian Ocean Territory', id: 'IO'},
        {value: 'Brunei Darussalam', id: 'BN'},
        {value: 'Bulgaria', id: 'BG'},
        {value: 'Burkina Faso', id: 'BF'},
        {value: 'Burundi', id: 'BI'},
        {value: 'Cambodia', id: 'KH'},
        {value: 'Cameroon', id: 'CM'},
        {value: 'Canada', id: 'CA'},
        {value: 'Cape Verde', id: 'CV'},
        {value: 'Cayman Islands', id: 'KY'},
        {value: 'Central African Republic', id: 'CF'},
        {value: 'Chad', id: 'TD'},
        {value: 'Chile', id: 'CL'},
        {value: 'China', id: 'CN'},
        {value: 'Christmas Island', id: 'CX'},
        {value: 'Cocos (Keeling) Islands', id: 'CC'},
        {value: 'Colombia', id: 'CO'},
        {value: 'Comoros', id: 'KM'},
        {value: 'Congo', id: 'CG'},
        {value: 'Congo, The Democratic Republic of the', id: 'CD'},
        {value: 'Cook Islands', id: 'CK'},
        {value: 'Costa Rica', id: 'CR'},
        {value: 'Cote D\'Ivoire', id: 'CI'},
        {value: 'Croatia', id: 'HR'},
        {value: 'Cuba', id: 'CU'},
        {value: 'Cyprus', id: 'CY'},
        {value: 'Czech Republic', id: 'CZ'},
        {value: 'Denmark', id: 'DK'},
        {value: 'Djibouti', id: 'DJ'},
        {value: 'Dominica', id: 'DM'},
        {value: 'Dominican Republic', id: 'DO'},
        {value: 'Ecuador', id: 'EC'},
        {value: 'Egypt', id: 'EG'},
        {value: 'El Salvador', id: 'SV'},
        {value: 'Equatorial Guinea', id: 'GQ'},
        {value: 'Eritrea', id: 'ER'},
        {value: 'Estonia', id: 'EE'},
        {value: 'Ethiopia', id: 'ET'},
        {value: 'Falkland Islands (Malvinas)', id: 'FK'},
        {value: 'Faroe Islands', id: 'FO'},
        {value: 'Fiji', id: 'FJ'},
        {value: 'Finland', id: 'FI'},
        {value: 'France', id: 'FR'},
        {value: 'French Guiana', id: 'GF'},
        {value: 'French Polynesia', id: 'PF'},
        {value: 'French Southern Territories', id: 'TF'},
        {value: 'Gabon', id: 'GA'},
        {value: 'Gambia', id: 'GM'},
        {value: 'Georgia', id: 'GE'},
        {value: 'Germany', id: 'DE'},
        {value: 'Ghana', id: 'GH'},
        {value: 'Gibraltar', id: 'GI'},
        {value: 'Greece', id: 'GR'},
        {value: 'Greenland', id: 'GL'},
        {value: 'Grenada', id: 'GD'},
        {value: 'Guadeloupe', id: 'GP'},
        {value: 'Guam', id: 'GU'},
        {value: 'Guatemala', id: 'GT'},
        {value: 'Guernsey', id: 'GG'},
        {value: 'Guinea', id: 'GN'},
        {value: 'Guinea-Bissau', id: 'GW'},
        {value: 'Guyana', id: 'GY'},
        {value: 'Haiti', id: 'HT'},
        {value: 'Heard Island and Mcdonald Islands', id: 'HM'},
        {value: 'Holy See (Vatican City State)', id: 'VA'},
        {value: 'Honduras', id: 'HN'},
        {value: 'Hong Kong', id: 'HK'},
        {value: 'Hungary', id: 'HU'},
        {value: 'Iceland', id: 'IS'},
        {value: 'India', id: 'IN'},
        {value: 'Indonesia', id: 'ID'},
        {value: 'Iran, Islamic Republic Of', id: 'IR'},
        {value: 'Iraq', id: 'IQ'},
        {value: 'Ireland', id: 'IE'},
        {value: 'Isle of Man', id: 'IM'},
        {value: 'Israel', id: 'IL'},
        {value: 'Italy', id: 'IT'},
        {value: 'Jamaica', id: 'JM'},
        {value: 'Japan', id: 'JP'},
        {value: 'Jersey', id: 'JE'},
        {value: 'Jordan', id: 'JO'},
        {value: 'Kazakhstan', id: 'KZ'},
        {value: 'Kenya', id: 'KE'},
        {value: 'Kiribati', id: 'KI'},
        {value: 'Korea, Democratic People\'S Republic of', id: 'KP'},
        {value: 'Korea, Republic of', id: 'KR'},
        {value: 'Kuwait', id: 'KW'},
        {value: 'Kyrgyzstan', id: 'KG'},
        {value: 'Lao People\'S Democratic Republic', id: 'LA'},
        {value: 'Latvia', id: 'LV'},
        {value: 'Lebanon', id: 'LB'},
        {value: 'Lesotho', id: 'LS'},
        {value: 'Liberia', id: 'LR'},
        {value: 'Libyan Arab Jamahiriya', id: 'LY'},
        {value: 'Liechtenstein', id: 'LI'},
        {value: 'Lithuania', id: 'LT'},
        {value: 'Luxembourg', id: 'LU'},
        {value: 'Macao', id: 'MO'},
        {value: 'Macedonia, The Former Yugoslav Republic of', id: 'MK'},
        {value: 'Madagascar', id: 'MG'},
        {value: 'Malawi', id: 'MW'},
        {value: 'Malaysia', id: 'MY'},
        {value: 'Maldives', id: 'MV'},
        {value: 'Mali', id: 'ML'},
        {value: 'Malta', id: 'MT'},
        {value: 'Marshall Islands', id: 'MH'},
        {value: 'Martinique', id: 'MQ'},
        {value: 'Mauritania', id: 'MR'},
        {value: 'Mauritius', id: 'MU'},
        {value: 'Mayotte', id: 'YT'},
        {value: 'Mexico', id: 'MX'},
        {value: 'Micronesia, Federated States of', id: 'FM'},
        {value: 'Moldova, Republic of', id: 'MD'},
        {value: 'Monaco', id: 'MC'},
        {value: 'Mongolia', id: 'MN'},
        {value: 'Montserrat', id: 'MS'},
        {value: 'Morocco', id: 'MA'},
        {value: 'Mozambique', id: 'MZ'},
        {value: 'Myanmar', id: 'MM'},
        {value: 'Namibia', id: 'NA'},
        {value: 'Nauru', id: 'NR'},
        {value: 'Nepal', id: 'NP'},
        {value: 'Netherlands', id: 'NL'},
        {value: 'Netherlands Antilles', id: 'AN'},
        {value: 'New Caledonia', id: 'NC'},
        {value: 'New Zealand', id: 'NZ'},
        {value: 'Nicaragua', id: 'NI'},
        {value: 'Niger', id: 'NE'},
        {value: 'Nigeria', id: 'NG'},
        {value: 'Niue', id: 'NU'},
        {value: 'Norfolk Island', id: 'NF'},
        {value: 'Northern Mariana Islands', id: 'MP'},
        {value: 'Norway', id: 'NO'},
        {value: 'Oman', id: 'OM'},
        {value: 'Pakistan', id: 'PK'},
        {value: 'Palau', id: 'PW'},
        {value: 'Palestinian Territory, Occupied', id: 'PS'},
        {value: 'Panama', id: 'PA'},
        {value: 'Papua New Guinea', id: 'PG'},
        {value: 'Paraguay', id: 'PY'},
        {value: 'Peru', id: 'PE'},
        {value: 'Philippines', id: 'PH'},
        {value: 'Pitcairn', id: 'PN'},
        {value: 'Poland', id: 'PL'},
        {value: 'Portugal', id: 'PT'},
        {value: 'Puerto Rico', id: 'PR'},
        {value: 'Qatar', id: 'QA'},
        {value: 'Reunion', id: 'RE'},
        {value: 'Romania', id: 'RO'},
        {value: 'Russian Federation', id: 'RU'},
        {value: 'RWANDA', id: 'RW'},
        {value: 'Saint Helena', id: 'SH'},
        {value: 'Saint Kitts and Nevis', id: 'KN'},
        {value: 'Saint Lucia', id: 'LC'},
        {value: 'Saint Pierre and Miquelon', id: 'PM'},
        {value: 'Saint Vincent and the Grenadines', id: 'VC'},
        {value: 'Samoa', id: 'WS'},
        {value: 'San Marino', id: 'SM'},
        {value: 'Sao Tome and Principe', id: 'ST'},
        {value: 'Saudi Arabia', id: 'SA'},
        {value: 'Senegal', id: 'SN'},
        {value: 'Serbia and Montenegro', id: 'CS'},
        {value: 'Seychelles', id: 'SC'},
        {value: 'Sierra Leone', id: 'SL'},
        {value: 'Singapore', id: 'SG'},
        {value: 'Slovakia', id: 'SK'},
        {value: 'Slovenia', id: 'SI'},
        {value: 'Solomon Islands', id: 'SB'},
        {value: 'Somalia', id: 'SO'},
        {value: 'South Africa', id: 'ZA'},
        {value: 'South Georgia and the South Sandwich Islands', id: 'GS'},
        {value: 'Spain', id: 'ES'},
        {value: 'Sri Lanka', id: 'LK'},
        {value: 'Sudan', id: 'SD'},
        {value: 'Surivalue', id: 'SR'},
        {value: 'Svalbard and Jan Mayen', id: 'SJ'},
        {value: 'Swaziland', id: 'SZ'},
        {value: 'Sweden', id: 'SE'},
        {value: 'Switzerland', id: 'CH'},
        {value: 'Syrian Arab Republic', id: 'SY'},
        {value: 'Taiwan, Province of China', id: 'TW'},
        {value: 'Tajikistan', id: 'TJ'},
        {value: 'Tanzania, United Republic of', id: 'TZ'},
        {value: 'Thailand', id: 'TH'},
        {value: 'Timor-Leste', id: 'TL'},
        {value: 'Togo', id: 'TG'},
        {value: 'Tokelau', id: 'TK'},
        {value: 'Tonga', id: 'TO'},
        {value: 'Trinidad and Tobago', id: 'TT'},
        {value: 'Tunisia', id: 'TN'},
        {value: 'Turkey', id: 'TR'},
        {value: 'Turkmenistan', id: 'TM'},
        {value: 'Turks and Caicos Islands', id: 'TC'},
        {value: 'Tuvalu', id: 'TV'},
        {value: 'Uganda', id: 'UG'},
        {value: 'Ukraine', id: 'UA'},
        {value: 'United Arab Emirates', id: 'AE'},
        {value: 'United Kingdom', id: 'GB'},
        {value: 'United States', id: 'US'},
        {value: 'United States Minor Outlying Islands', id: 'UM'},
        {value: 'Uruguay', id: 'UY'},
        {value: 'Uzbekistan', id: 'UZ'},
        {value: 'Vanuatu', id: 'VU'},
        {value: 'Venezuela', id: 'VE'},
        {value: 'Viet Nam', id: 'VN'},
        {value: 'Virgin Islands, British', id: 'VG'},
        {value: 'Virgin Islands, U.S.', id: 'VI'},
        {value: 'Wallis and Futuna', id: 'WF'},
        {value: 'Western Sahara', id: 'EH'},
        {value: 'Yemen', id: 'YE'},
        {value: 'Zambia', id: 'ZM'},
        {value: 'Zimbabwe', id: 'ZW'}
    ]
    let isValidInputs = true;
        const [firstName, setFirstName] = useState("");
        const [firstNameErr, setFirstNameErr] = useState(false);
        const [lastName, setLastName] = useState("");
        const [lastNameErr, setLastNameErr] = useState(false);
        const [phone, setPhone] = useState("");
        const [phoneErr, setPhoneErr] = useState(false);
        const [email, setEmail] = useState("");
        const [emailErr, setEmailErr] = useState(false);
        const [jobTitle, setJobTitle] = useState("");
        const [jobTitleErr, setJobTitleErr] = useState(false);
        const [companyName, setCompanyName] = useState("");
        const [companyNameErr, setCompanyNameErr] = useState(false);
        const [country, setCountry] = useState('United States');
        const [typeOfPartner, setTypeOfPartner] = useState('Integration');
        const [desc, setDesc] = useState('');
        const [descErr, setDescErr] = useState(false);
        const [querySent, setQuerySent] = useState(false);
        const [querySentText, setQuerySentText] = useState("Thanks for reaching out! We will look over your message and get back to you soon");

        const validateInputs = () => {
            const phoneRegEx = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
            const emailRegEx = /^([\w-\.]+@(?!gmail.com)(?!yahoo.com)(?!hotmail.com)(?!yahoo.co.in)(?!aol.com)(?!abc.com)(?!xyz.com)(?!pqr.com)(?!rediffmail.com)(?!live.com)(?!outlook.com)(?!me.com)(?!msn.com)(?!ymail.com)([\w-]+\.)+[\w-]{2,4})?$/;

            let emailId = email
            let isInvalidEmail = emailId.length < 2 || !emailRegEx.test(String(emailId).toLowerCase())
            let isInvalidFirstName = firstName.length < 3
            let isInvalidLastName = lastName.length < 3
            let isInvalidPhone = phone.length < 3 || !phoneRegEx.test((phone).toLowerCase())
            let isInvalidJobTitle = jobTitle.length < 3
            let isInvalidCompanyName = companyName.length < 1
            let isInvalidDesc = desc.length < 3

            if(isInvalidEmail){
                setEmailErr(true)
            }
            if(isInvalidFirstName){
                setFirstNameErr(true)
            }
            if(isInvalidLastName){
                setLastNameErr(true)
            }
            if(isInvalidPhone){
                setPhoneErr(true)
            }
            if(isInvalidJobTitle){
                setJobTitleErr(true)
            }
            if(isInvalidCompanyName){
                setCompanyNameErr(true)
            }
            if(isInvalidDesc){
                setDescErr(true)
            }

            isValidInputs = !isInvalidEmail && !isInvalidFirstName && !isInvalidLastName && !isInvalidPhone && !isInvalidJobTitle  && !isInvalidCompanyName && !isInvalidDesc
        }
        const handleSubmit = (e) => {
            e.preventDefault()
            validateInputs()
            if(isValidInputs){
                var xhr = new XMLHttpRequest();
                var url = "https://api.hsforms.com/submissions/v3/integration/submit/25310090/3002f11c-1570-467c-b07f-f306f113411b";
                var data = {
                    submittedAt: Date.now(),
                    fields: [
                        {
                            name: "firstname",
                            value: firstName,
                        },
                        {
                            name: "lastname",
                            value: lastName,
                        },
                        {
                            name: "email",
                            value: email,
                        },
                        {
                            name: "phone",
                            value: phone,
                        },
                        {
                            name: "jobtitle",
                            value: jobTitle,
                        },
                        {
                            name: "company",
                            value: companyName,
                        },
                        {
                            name: "country",
                            value: country,
                        },
                        {
                            name: "type_of_partner",
                            value: typeOfPartner,
                        },
                        {
                            name: "description",
                            value: desc,
                        },
                        {
                            name: "source_type",
                            value: 'Partner',
                        },

                    ],
                };
                var final_data = JSON.stringify(data);
                xhr.open("POST", url);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        setEmail('')
                        setFirstName('')
                        setJobTitle('')
                        setCompanyName('')
                        setLastName('')
                        setPhone('')
                        setDesc('')
                        setQuerySent(true)
                        setTimeout(()=>{
                            setQuerySent(false)
                        },6000)
                        // Returns a 200 response if the submission is successful.
                    } else if (xhr.readyState == 4 && xhr.status == 400) {
                        setQuerySentText(xhr.responseText)
                    } else if (xhr.readyState == 4 && xhr.status == 403) {
                        setQuerySentText(xhr.responseText)
                    }
                };
                xhr.send(final_data);
            }
        }


    return (
        <>
            <div className={'form partner-form-pop'}>
                <form onSubmit={(e) => handleSubmit(e)}>
                    <div className={'d-flex'}>
                        <div className={'input-wrapper'}>
                            <label>First Name</label>
                            <input type={'text'} placeholder={'Your First Name'}
                                   className={`${firstNameErr ? 'is-error' : ''}`}
                                   value={firstName}
                                   onChange={(e) => {
                                       const value = e.target && e.target.value
                                       setFirstName(value)
                                   }}
                                   onKeyUp={(e) => {
                                       if (firstName.length > 0) {
                                           setFirstNameErr(false)
                                       }
                                   }}
                            />
                            <h6 className={`form-input-validation ${firstNameErr ? 'error' : ''}`}>Minimum 3 characters
                                required</h6>
                        </div>
                        <div className={'input-wrapper'}>
                            <label>Last Name</label>
                            <input type={'text'} placeholder={'Your Last Name'}
                                   className={`${lastNameErr ? 'is-error' : ''}`}
                                   value={lastName}
                                   onChange={(e) => {
                                       const value = e.target && e.target.value
                                       setLastName(value)
                                   }}
                                   onKeyUp={(e) => {
                                       if (lastName.length > 0) {
                                           setLastNameErr(false)
                                       }
                                   }}
                            />
                            <h6 className={`form-input-validation ${lastNameErr ? 'error' : ''}`}>Minimum 3 characters
                                required</h6>
                        </div>
                    </div>
                    <div className={'d-flex'}>
                        <div className={'input-wrapper'}>
                            <label>Business Email</label>
                            <input type={'email'} placeholder={'youremail@company.com'}
                                   className={`${emailErr ? 'is-error' : ''}`}
                                   value={email}
                                   onChange={(e) => {
                                       const value = e.target && e.target.value
                                       setEmail(value)
                                   }}
                                   onKeyUp={(e) => {
                                       if (email.length > 0) {
                                           setEmailErr(false)
                                       }
                                   }}
                            />
                            <h6 className={`form-input-validation ${emailErr ? 'error' : ''}`}>{email.length < 1 ? 'Email is required' : 'Please enter business email'}</h6>
                        </div>

                        <div className={'input-wrapper'}>
                            <label>Job Title</label>
                            <input type={'text'} placeholder={'Your job title'}
                                   className={`${jobTitleErr ? 'is-error' : ''}`}
                                   value={jobTitle}
                                   onChange={(e) => {
                                       const value = e.target && e.target.value
                                       setJobTitle(value)
                                   }}
                                   onKeyUp={(e) => {
                                       if (jobTitle.length > 0) {
                                           setJobTitleErr(false)
                                       }
                                   }}
                            />
                            <h6 className={`form-input-validation ${jobTitleErr ? 'error' : ''}`}>Minimum 3 characters
                                required</h6>
                        </div>
                    </div>
                    <div className={'d-flex'}>
                        <div className={'input-wrapper'}>
                            <label>Phone Number</label>
                            <input type={'tel'} placeholder={'Your Phone Number'}
                                   className={`${phoneErr ? 'is-error' : ''}`}
                                   value={phone}
                                   onChange={(e) => {
                                       const value = e.target && e.target.value
                                       setPhone(value)
                                   }}
                                   onKeyUp={(e) => {
                                       if (phone.length > 0) {
                                           setPhoneErr(false)
                                       }
                                   }}
                            />
                            <h6 className={`form-input-validation ${phoneErr ? 'error' : ''}`}>{phone.length < 1 ? 'Phone number is required' : 'Invalid phone number'}</h6>
                        </div>
                        <div className={'input-wrapper'}>
                            <label>Company name</label>
                            <input type={'text'} placeholder={'Your Company Name'}
                                   className={`${companyNameErr ? 'is-error' : ''}`}
                                   value={companyName}
                                   onChange={(e) => {
                                       const value = e.target && e.target.value
                                       setCompanyName(value)
                                   }}
                                   onKeyUp={(e) => {
                                       if (companyName.length > 0) {
                                           setCompanyNameErr(false)
                                       }
                                   }}
                            />
                            <h6 className={`form-input-validation ${companyNameErr ? 'error' : ''}`}>Company name is
                                required</h6>
                        </div>
                    </div>
                    <div className={'d-flex res-overlap'}>
                        <div className={'input-wrapper'}>
                            <label>Country/Region</label>
                            <SelectBox
                                items={countryList}
                                defaultSelectedItemIndex={229}
                                onChange={(e) => {
                                    setCountry(e.value)
                                }}
                            />
                        </div>
                        <div className={'input-wrapper'}>
                            <label>Type of Partner</label>
                            <SelectBox
                                items={[
                                    {value: "Technology", id: 1},
                                    {value: "Sales", id: 2},
                                    {value: "Affiliate Marketing", id: 3},
                                ]}
                                onChange={(e) => {
                                    setTypeOfPartner(e.value)
                                }}
                            />
                        </div>
                    </div>
                    <div className={'input-wrapper'}>
                        <label>Description</label>
                        <textarea value={desc}
                                  className={`${descErr ? 'is-error' : ''}`}
                                  onChange={(e) => {
                                      const value = e.target && e.target.value
                                      setDesc(value)
                                  }}
                                  onKeyUp={(e) => {
                                      if (firstName.length > 0) {
                                          setDescErr(false)
                                      }
                                  }}></textarea>
                        <h6 className={`form-input-validation ${descErr ? 'error' : ''}`}>Minimum 3 characters
                            required</h6>
                    </div>
                    <button type={'submit'} className={'primary'}>Lets do this!</button>
                    {querySent &&
                        <h6 className={`form-input-validation ${querySent ? 'success' : 'error'}`}>{querySentText}</h6>}
                </form>
            </div>
        </>
    )
}

export default PartnersForm;